module.exports = __webpack_public_path__ + "img/5.838d0403.png";